import { UrlConstants } from "../url.constants";
export class ApiTrainingModuleConstants {
    static URL = UrlConstants.API_V2 + "TrainingModule";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetTrainingModuleProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateTrainingModuleInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalTrainingModuleApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetTrainingModuleRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetTmApplicationTypes";
}
